module.exports = __webpack_public_path__ + "img/logo_full.5fcb3d9.svg?v=1747134756265";